/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Value_Ethics_TitleInputs */



/**
* | output |
* | --- |
* | "Ethics and inclusion" |
*
* @param {About_Value_Ethics_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const about_value_ethics_title = /** @type {((inputs?: About_Value_Ethics_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Value_Ethics_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("道德与包容")
	return /** @type {LocalizedString} */ ("Ethics and inclusion")
});